import React from "react";

// 챗 메시지 컴포넌트
const ChatMessage = ({ message, url }) => {
  const cleanMessage = (typeof message === 'string' && message) ? message.replace(/\\r/g, '') : message;
  
  return url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-500 underline break-all whitespace-pre-line"
    >
      {cleanMessage}
    </a>
  ) : (
    <p className="break-all whitespace-pre-line">{cleanMessage}</p>
  );
};

export default ChatMessage;
